export {
  ActivitiesHistory,
  default,
  type ActivitiesHistoryProps,
} from './ActivitiesHistory';
